/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
import * as LogoComponents from '../icons/logos';

import styles from '../../../styles/partials/partners.scss';
import pressKit from '../../../docs/PressKit_FindingSally_june2020.pdf';

const propTypes = {
    partners: PropTypes.arrayOf(
        PropTypes.shape({
            component: PropTypes.string,
            label: PropTypes.string,
            url: PropTypes.string,
        }),
    ),
    className: PropTypes.string,
};

const defaultProps = {
    partners: [
        {
            component: 'CMF',
            label: 'CMF',
            url: 'https://www.cmf-fmc.ca',
        },
        {
            component: 'DocChannel',
            label: 'Documentary Channel',
            url: 'https://www.cbc.ca/documentarychannel/',
        },
        {
            component: 'Catbird',
            label: 'Catbird',
            url: 'https://catbirdproductions.ca',
        },
        {
            component: 'OAC',
            label: 'Ontario Arts Council',
            url: 'https://www.arts.on.ca/',
        },
        {
            component: 'Canada',
            label: 'Canada Tax credits',
            url: 'https://www.canada.ca',
        },
        {
            component: 'Gobez',
            label: 'Gobez Media',
            url: 'https://www.gobez.ca/',
        },
        {
            component: 'Politica',
            label: 'Cinema Politica',
            url: 'https://www.cinemapolitica.org/',
        },
        {
            component: 'Rise',
            label: 'RiseAndShine',
            url: 'http://www.riseandshine-berlin.de/',
        },
    ],
    className: null,
};

const Partners = ({ partners, className }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <div className={styles.inner}>
            <ul className={styles.items}>
                {partners.map(({ label, component, url }) => {
                    const LogoComponent = LogoComponents[component] || null;
                    return LogoComponent !== null ? (
                        <li key={`partner-${label}`} className={styles.item}>
                            <a href={url} title={label} target="_blank" className={styles.link}>
                                <LogoComponent className={styles.logo} />
                            </a>
                        </li>
                    ) : null;
                })}
                <li className={classNames(styles.item, styles.presskit)}>
                    <a href={pressKit} download="PressKit_FindingSally.pdf">
                        Download &nbsp; Presskit
                    </a>
                </li>
            </ul>
        </div>
    </div>
);

Partners.propTypes = propTypes;
Partners.defaultProps = defaultProps;

export default Partners;
